import { gql } from 'graphql-tag'
import fragmentModuleNavigationLink from '../../modules/module-navigation-link/fragment-module-navigation-link'
import fragmentModuleMedia from '../../modules/module-media/fragment-module-media'
import fragmentModuleVideo from '../../modules/module-video/fragment-module-video'

export default gql`
  ${fragmentModuleNavigationLink}
  ${fragmentModuleMedia}
  ${fragmentModuleVideo}
  fragment BlockCampaignsCardsItemFragment on BlockCampaignsCardsItem {
    title
    text
    link {
      ...ModuleNavigationLinkFragment
    }
    image {
      ...ModuleMediaFragment
    }
    video {
      ...ModuleVideoFragment
    }
  }
`
